<div class="alert alert-danger" role="alert">
    {{ message }}
</div>